<template>
  <div id="teacher_basic">
    <div class="over_ta">
      <div class="tea_li">
        <div class="tea_li_l2">
          <div class="tea_lititle">{{teacher.nameEn}} {{teacher.nameCh}}</div>
          <div class="tea_tx" v-for="(background,index) in teacher.background" :key="index">
            <span class="tea_tg">{{showDegree(background)}}</span> {{showSchool(background)}}, {{background.graduation_year}}
          </div>
          <div class="tea_tx mt15">{{showPage.officeLocation}} : {{teacher.office}}</div>
          <div class="tea_tx">{{showPage.tel}} : {{teacher.tel}}</div>
          <div class="tea_tx">Email : {{teacher.email}}</div>
          <div class="tea_tx">{{showPage.consultationTime}} : {{teacher.advisory}}</div>
          <div class="tea_tx">{{showPage.personalWebpage}} : {{teacher.website}}</div>
          <div style="height:15px;border-bottom:#ddd 1px solid;"></div>
          <div class="tea_tx mt15">{{showTitle(teacher.title)}}</div>
          <div class="tea_tx" v-for="(subTitle,index) in teacher.subTitle" :key="index">{{subTitle}}</div>
        </div>
        <div class="tea_li_r2"><img v-if="teacher.profileImage" :src="teacher.profileImage">
          <img v-else src="/../static/images/timeline-default-photo.gif"></div>
        <div class="fix"></div>
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showPage.researchArea}}</div>
        <div class="tea_tx" v-for="(researchArea,index) in teacher.researchArea" :key="index">{{showResearchArea(researchArea)}}</div>
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showPage.researchSummary}}</div>
        <div class="tea_tx" v-html="showResearchSummary()">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_basic',
  props: ['teacher'],
  data() {
    return {
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {},
  methods: {


    showDegree(background) {
      let degreeEn = { '學士': 'Bachelor', '碩士': 'Master', '博士': 'Doctor' },
        degree = { CH: background.degree, EN: degreeEn[background.degree] };
      return degree[sessionStorage.locale];
    },
    showSchool(background) {
      let school = { CH: background.school_ch, EN: background.school_en };
      return school[sessionStorage.locale];
    },
    showTitle(title) {
      let titlename = ['', this.showPage.professor, this.showPage.associateProfessor, this.showPage.assistantProfessor,
        this.showPage.distinguishedProfessor, this.showPage.fullTimeLecturer, this.showPage.adjunctProfessor,
        this.showPage.adjunctAssociateProfessor, this.showPage.adjunctAssistantProfessor, this.showPage.adjunctLecture,
        this.showPage.teachingAssistant
      ];
      return titlename[title];
    },
    showResearchArea(researchArea) {
      let research = { CH: researchArea.research_area_ch, EN: researchArea.research_area_en };
      return research[sessionStorage.locale];
    },
    showResearchSummary() {
      let research = { CH: (this.teacher.researchSummaryCh), EN: (this.teacher.researchSummaryEn) };
      return research[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// TeacherBasic.vue?0a256c12